import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-sm shadow-sm" data-id="element-116">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-117">
        <div className="flex-shrink-0" data-id="element-118">
          <h1 className="text-xl font-serif font-bold text-[#1A3C2A]" data-id="element-119">
            MyoQuell<span className="text-xs align-top" data-id="element-120">™</span>
          </h1>
          <p className="text-xs text-[#6B9C37] -mt-1" data-id="element-121">Herbal Knee Patches</p>
        </div>
        <div className="flex items-center space-x-4 text-sm" data-id="element-122">
          <a href="#reviews" className="hidden sm:flex items-center hover:text-[#6B9C37]" data-id="element-123">
            <span className="text-amber-400" data-id="element-124">★★★★★</span>
            <span className="ml-1" data-id="element-125">Reviews</span>
          </a>
          <a href="#" className="hidden sm:block hover:text-[#6B9C37]" data-id="element-126">
            Track Order
          </a>
          <button className="relative hover:text-[#6B9C37]" aria-label="Cart" data-id="element-127">
            <ShoppingCartIcon size={20} data-id="element-128" />
            <span className="absolute -top-1 -right-1 bg-[#6B9C37] text-white text-xs rounded-full w-4 h-4 flex items-center justify-center" data-id="element-129">
              0
            </span>
          </button>
        </div>
      </div>
    </header>;
}